import axios from "api/axios";

export async function fetchCompanies(params = {}) {
  const { data } = await axios.get("/companies", { params });
  return data;
}

export async function createCompany(payload) {
  const { data } = await axios.post("/companies", payload);
  return data;
}

export async function updateCompany(id, payload) {
  const { data } = await axios.put(`/companies/${id}`, payload);
  return data;
}

export async function deleteCompany(id) {
  const { data } = await axios.delete(`/companies/${id}`);
  return data;
}

export async function fetchBranches(params = {}) {
  const { data } = await axios.get("/branches", { params });
  return data;
}

export async function createBranch(payload) {
  const { data } = await axios.post("/branches", payload);
  return data;
}

export async function updateBranch(id, payload) {
  const { data } = await axios.put(`/branches/${id}`, payload);
  return data;
}

export async function deleteBranch(id) {
  const { data } = await axios.delete(`/branches/${id}`);
  return data;
}

export async function fetchDepartments(params = {}) {
  const { data } = await axios.get("/departments", { params });
  return data;
}

export async function createDepartment(payload) {
  const { data } = await axios.post("/departments", payload);
  return data;
}

export async function updateDepartment(id, payload) {
  const { data } = await axios.put(`/departments/${id}`, payload);
  return data;
}

export async function deleteDepartment(id) {
  const { data } = await axios.delete(`/departments/${id}`);
  return data;
}
